import { isApiProfile, isExploreProfile } from 'domain/profile';
import { PROFILE_TYPES } from 'variables';
import { ProfileType } from 'types/types';
import { formatDateFromIsoString } from '@insights-ltd/design-library/utils';
import { ArchivedProfileResponse, ProfileResponse } from 'api';

type Profile = ProfileResponse | ArchivedProfileResponse;

export const getProfileDates = (
  profile: Profile,
  locale: string,
): { completionDate: string; createdDate: string } => ({
  completionDate: formatDateFromIsoString(
    profile.evaluationSubmittedOn,
    locale,
  ),
  createdDate: formatDateFromIsoString(profile.createdAt, locale),
});

export const getProfileTitleKey = (profile: Profile): string =>
  PROFILE_TYPES[profile.type];

export const getIsDiscoveryProfile = (type: ProfileType): boolean =>
  type === 'DISCOVERY_PROFILE' || type === 'DISCOVERY_PERSONAL_PROFILE';

export const getIsProfileShareable = (
  profile: Profile,
  disabledDFCProfileTile: boolean,
): boolean =>
  !isExploreProfile(profile) &&
  !isApiProfile(profile) &&
  !disabledDFCProfileTile;
